var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.matching
    ? _c(
        "div",
        { class: { matching: true, "narrow-label": _vm.narrowLabel } },
        [
          _c("MatchingOverview", {
            attrs: {
              matching: _vm.matching,
              clickable: true,
              "with-percentage": false
            },
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }